import { render, staticRenderFns } from "./NotificationDetails.vue?vue&type=template&id=2ac2a24e&scoped=true"
import script from "./NotificationDetails.vue?vue&type=script&lang=js"
export * from "./NotificationDetails.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetails.vue?vue&type=style&index=0&id=2ac2a24e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2a24e",
  null
  
)

export default component.exports